import { LabelRegular, YStack } from 'smoothie';

import { LegalLink } from '../common/LegalLink';
import { FootnoteTitle, type FootnoteTitleProps } from './FootnoteTitle';
import { REWARDS_TC_LABEL, REWARDS_TC_URL } from './legal';

export const CashBackDisclosure = ({
    color = '$gray900',
    titleColor,
    superscript,
}: {
    color?: string;
    titleColor?: string;
    superscript?: FootnoteTitleProps['superscript'];
}) => {
    return (
        <YStack>
            <FootnoteTitle
                title="Fruitful Card"
                superscript={superscript}
                color={titleColor}
            />
            <LabelRegular color={color}>
                Members are eligible for 2% cash back if they have a Premium
                Membership or have a Solo, Joint, Essential, or Plus Membership
                and receive a qualifying direct deposit into their Fruitful Cash
                Account. Members who do not meet these requirements earn 1% cash
                back. See the{' '}
                <LegalLink href={REWARDS_TC_URL} color={color}>
                    {REWARDS_TC_LABEL}
                </LegalLink>{' '}
                for complete details.
            </LabelRegular>
        </YStack>
    );
};
